<div class="offer-modification-dialog">
  <h2 class="offer-modification-dialog__header">{{ getTranslationKey('header') | translate | uppercase }}</h2>
  <div class="offer-modification-dialog__image-wrapper">
    <img class="offer-modification-dialog__image" [src]="imageSrc" alt="">
  </div>
  <p class="offer-modification-dialog__paragraph">{{ getTranslationKey('paragraph1') | translate }}</p>
  <p class="offer-modification-dialog__paragraph" [innerHTML]="getTranslationKey('paragraph2') | translate | safeHtml "></p>
  <p class="offer-modification-dialog__paragraph">{{ getTranslationKey('paragraph3') | translate }}</p>
</div>
